/* Diente — collection filtering, sorting and the mobile filter drawer.
   Filters come from Shopify Search & Discovery via collection.filters; this
   only turns the form into an async, URL-driven experience. */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var wrapper = root.querySelector('[data-facets-wrapper]');
  var form = root.querySelector('[data-facet-form]');
  var pending = null;

  /* ------------------------------------------------------- mobile drawer */

  function openDrawer() {
    if (!wrapper) return;
    wrapper.classList.add('is-open');
    document.body.classList.add('overlay-open');
  }

  function closeDrawer() {
    if (!wrapper) return;
    wrapper.classList.remove('is-open');
    document.body.classList.remove('overlay-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-facets-open]')) {
      event.preventDefault();
      openDrawer();
    } else if (event.target.closest('[data-facets-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && wrapper && wrapper.classList.contains('is-open')) closeDrawer();
  });

  /* ----------------------------------------------------------- price slider */

  function bindPriceSliders(scope) {
    scope.querySelectorAll('[data-price-slider]').forEach(function (slider) {
      var group = slider.closest('.facet-group');
      var hidden = group.querySelector('[data-price-input]');
      var output = group.querySelector('[data-price-output]');

      slider.addEventListener('input', function () {
        if (output) output.textContent = slider.value;
      });

      slider.addEventListener('change', function () {
        // An untouched max means "no price filter" — leave the param empty.
        hidden.value = Number(slider.value) >= Number(slider.max) ? '' : slider.value;
        applyFilters();
      });
    });
  }

  /* --------------------------------------------------------------- fetching */

  function buildUrl() {
    var params = new URLSearchParams();

    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '' && value != null) params.append(key, value);
      });
    }

    var base = window.location.pathname;
    var query = params.toString();
    return query ? base + '?' + query : base;
  }

  function applyFilters() {
    var url = buildUrl();

    root.classList.add('is-loading');
    if (pending) pending.abort();
    pending = new AbortController();

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    fetch(fetchUrl, { signal: pending.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var freshMain = parsed.querySelector('[data-collection-main]');
        var currentMain = root.querySelector('[data-collection-main]');
        if (freshMain && currentMain) currentMain.replaceWith(freshMain);

        // Refresh facet counts without tearing down the open drawer.
        var freshFacets = parsed.querySelector('.facets__body');
        var currentFacets = root.querySelector('.facets__body');
        if (freshFacets && currentFacets) {
          currentFacets.innerHTML = freshFacets.innerHTML;
          bindPriceSliders(currentFacets);
        }

        window.history.replaceState({}, '', url);
        document.dispatchEvent(new CustomEvent('wishlist:render'));

        // Active specification filters perform a second, final render and announce that result.
        if (root.getAttribute('data-dvk-spec-active') !== '1') {
          var status = freshMain && freshMain.getAttribute('data-results-message');
          if (status) window.Diente.announce(status);
        }
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') window.location.href = url;
      })
      .finally(function () {
        root.classList.remove('is-loading');
        pending = null;
      });
  }

  /* ---------------------------------------------------------------- events */

  if (form) {
    form.addEventListener('change', function (event) {
      // Sliders handle their own change event (they also write the hidden field).
      if (event.target.matches('[data-price-slider]')) return;
      applyFilters();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });

    bindPriceSliders(form);
  }

  root.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sort-select]');
    if (!select) return;

    var hidden = root.querySelector('[data-sort-input]');
    if (hidden) hidden.value = select.value;
    applyFilters();
  });
})();
